<script>
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    props: {
      logs: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      events: [],
      input: null,
      canSend: false,
      canMark: false,
      withDivider: false
    }),

    computed: {
      timeline() {
        return this.events.slice().reverse()
      }
    },
    watch: {
      logs() {
        this.updateEvents()
      }
    },

    mounted() {
      this.updateEvents()
    },

    methods: {
      updateEvents() {
        this.events = []
        _.each(this.logs, (l) => {
          this.events.push({...l})
        })
      },
      emitAction(message) {
        this.$emit('action', message)
      },
      markAsRead() {
        this.$store.dispatch('app/markasread')
      },
      comment() {
        const time = moment().format('HH:mm:ss')
        this.events.push({
          text: this.input,
          time: time
        })

        this.input = null
      }
    }
  }
</script>

<template>
  <VSheet class="messagelog">
    <VToolbar v-if="canMark" fixed light flat>
      <VTooltip v-slot:activator="{ on }" bottom>
        <VBtn icon text v-on="on" @click="markAsRead">
          <VIcon>mdi-check-box-outline</VIcon>
        </VBtn>
        <span>Als gelesen markieren</span>
      </VTooltip>
    </VToolbar>

    <h1 class="title mt-3">{{ $vuetify.lang.t('$vuetify.messages.title') }}</h1>

    <VTimeline dense clipped light>
      <VTimelineItem v-if="canSend" fill-dot class="mb-3" color="primary" large>
        <span slot="icon"><VIcon>mdi-comment</VIcon></span>
        <VTextField
          v-model="input"
          hide-details
          flat
          label="Nachricht erfassen..."
          solo
          @keydown.enter="comment"
        >
          <template slot="append">
            <VBtn class="mx-0" depressed @click="comment">
              Senden
            </VBtn>
          </template>
        </VTextField>
      </VTimelineItem>

      <VSlideXTransition group>
        <VTimelineItem
          v-for="event in timeline"
          :key="event.id"
          class="black--text mb-1"
          :color="event.color"
          small
        >
          <VLayout class="justify-space-between">
            <VFlex xs10>
              <VChip v-if="event.tag" class="ml-0 mb-2" :color="event.tagcolor" dark label small>{{ event.tag }}</VChip>
              <span v-if="event.tagtext" class="pl-4 overline font-italic font-weight-medium" v-text="event.tagtext"/>
              <div v-if="event.text" class="mb-2">{{ event.text }}</div>
              <div v-if="event.description" class="mb-2">{{ event.description }}</div>
            </VFlex>
            <VFlex xs2 text-xs-right v-text="event.time"></VFlex>
          </VLayout>
          <VBtn v-if="event.action" class="mx-0" small @click.left.stop="emitAction(event)">{{ event.action }}</VBtn>
        </VTimelineItem>
      </VSlideXTransition>

      <VTimelineItem v-if="withDivider" class="mb-4" hide-dot small>
        <span>{{ $vuetify.lang.t('$vuetify.search.relTime.today') }}</span>
      </VTimelineItem>
    </VTimeline>
  </VSheet>
</template>

<style lang="scss" scoped>
  .messagelog {
    padding: 0 24px;
  }
</style>
